<template>
  <div class="finance-taxation">
    <div style="display: flex; justify-content: space-between">
      <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()"
        >返回上一级</el-button
      >

      <div>
        <el-tooltip effect="dark" content="点击跳转到交接入审核列表" placement="top">
          <el-button type="warning" size="mini" @click="$router.push('finance_switch')"
            >交接入审核列表</el-button
          >
        </el-tooltip>
        <el-tooltip effect="dark" content="点击跳转到交接出审核列表" placement="top">
          <el-button type="warning" size="mini" @click="$router.push('ft_hand_out')"
            >交接出审核列表</el-button
          >
        </el-tooltip>
      </div>
    </div>
    <el-divider content-position="left">财税工厂</el-divider>
    <el-collapse style="border-top: none; margin-bottom: 0.2rem" id="collapse">
      <el-collapse-item>
        <template slot="title">
          <span style="color: #409eff; font-size: medium">筛选</span>
        </template>
        <el-card style="margin-bottom: 0.2rem">
          <el-row :gutter="20">
            <el-col :span="6">
              <span>所属业务</span>:
              <el-cascader
                style="width: 70%"
                v-model="searchArr.business_id"
                placeholder="所属业务"
                :options="typeinerOptions"
                size="medium"
                :props="{ multiple: true, expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                @mousedown.native="loadTypeiner"
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <el-col :span="11">
              <span>服务到期时间</span>:
              <!-- <el-date-picker size="medium" v-model="searchArr.service_time" type="daterange" align="right"
                                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
                            </el-date-picker> -->
              <el-date-picker
                size="medium"
                v-model="searchArr.service_time"
                type="monthrange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions"
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <span>所属财务</span>:
              <el-cascader
                style="width: 70%"
                v-model="searchArr.treasurer_id"
                placeholder="所属财务"
                :options="treasurerOptions"
                size="medium"
                :props="{ multiple: true, expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                @mousedown.native="loadTreasurer"
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
        </el-card>
        <div style="text-align: center; margin-top: 0.2rem">
          <el-button type="info" size="medium" @click="HandleReset()">重置</el-button>
          <el-button type="primary" size="medium" @click="HandleQuery()">查询</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div style="display: flex; margin-top: 0.2rem">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称"
        size="medium"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="margin-left: auto; display: flex; gap: 0.2rem">
        <!-- <div v-if="hasListPower"> -->
        <div>
          <div
            style="
              margin: auto;
              background-color: #409eff;
              color: aliceblue;
              padding: 11px 20px;
              border-radius: 5px;
            "
          >
            <label style="cursor: pointer">
              <input type="checkbox" v-model="onlyMe" @change="showOnlyMe" />
              <span>只展示我服务的公司</span>
            </label>
          </div>
        </div>
        <div>
          <!-- @visible-change="changeWord" -->
          <el-dropdown>
            <el-button type="primary" size="medium">
              {{ dropDownWord }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" style="padding: 0.2rem">
              <div
                style="
                  border-bottom: 1px solid #ccc;
                  display: flex;
                  justify-content: space-evenly;
                  margin-bottom: 0.2rem;
                  padding: 0.2rem 0;
                  align-items: center;
                "
              >
                <div style="vertical-align: middle">
                  <label style="cursor: pointer">
                    <span>全选</span>
                    <el-checkbox
                      v-model="dropDownChooseAllModel"
                      @change="dropDownChooseAllChange"
                    ></el-checkbox>
                  </label>
                </div>
                <div style="vertical-align: middle">
                  <label style="cursor: pointer">
                    <span>反选</span>
                    <el-checkbox
                      v-model="dropDownReverseModel"
                      @change="dropDownReverseChange"
                    ></el-checkbox>
                  </label>
                </div>
                <div style="vertical-align: middle">
                  <el-button type="primary" size="mini" @click="submitDropDownMethod"
                    >提交</el-button
                  >
                </div>
              </div>
              <el-checkbox-group v-model="dropDownCheckList">
                <el-checkbox
                  :label="item.key"
                  v-for="item in diyAllList"
                  :key="item.key"
                  style="display: block"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <el-drawer
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: large">录入</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="80px"
        >
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>面试人信息</span>
            </div>
            <div style="white-space: nowrap">
              <el-form-item
                label-width="75px"
                label="姓名"
                prop="name"
                style="display: inline-block; width: 50%"
              >
                <el-input
                  v-model.trim="categoryForm.name"
                  size="mini"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label-width="75px"
                label="手机号"
                prop="phone"
                style="display: inline-block; width: 50%"
              >
                <el-input
                  v-model.trim="categoryForm.phone"
                  size="mini"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label-width="75px" label="飞书链接" prop="feishuurl">
                <el-input
                  v-model.trim="categoryForm.feishuurl"
                  size="mini"
                  clearable
                ></el-input>
              </el-form-item>
              <upfile
                name="上传简历"
                :many="1"
                action="https://weixin.qiyehuo.com/api/recruit_manage_upfile"
                :mul="false"
                bus="ysyupfile"
                acc=".jpeg,.jpg,.png,.pdf"
                :acce="['img', 'pdf']"
              />
            </div>
          </el-card>
          <el-card shadow="always" style="margin-top: 0.2rem">
            <div slot="header" class="clearfix">
              <span>面试职位</span>
            </div>
            <div style="white-space: nowrap">
              <el-form-item
                label="部门"
                prop="branch_id"
                style="display: inline-block; width: 50%"
              >
                <el-select
                  v-model="categoryForm.branch_id"
                  placeholder="请选择"
                  @click.native="getUser"
                  size="mini"
                  clearable
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="reg in branch"
                    :key="reg.id"
                    :label="reg.name"
                    :value="reg.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="岗位"
                prop="station"
                style="display: inline-block; width: 50%"
              >
                <el-input
                  v-model.trim="categoryForm.station"
                  size="mini"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </el-card>
          <el-card shadow="always" style="margin-top: 0.2rem">
            <div slot="header" class="clearfix">
              <span>面试安排</span>
            </div>
            <div style="white-space: nowrap">
              <el-form-item
                label="面试时间"
                prop="meetAt"
                style="display: inline-block; width: 50%"
              >
                <el-date-picker
                  v-model="categoryForm.meetAt"
                  type="datetime"
                  align="right"
                  :picker-options="typeInPickerOptions"
                  default-time="12:00:00"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                  size="mini"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="面试地点"
                prop="meet_place"
                style="display: inline-block; width: 50%"
              >
                <el-radio-group v-model="categoryForm.meet_place" size="mini">
                  <el-radio-button label="1">静安</el-radio-button>
                  <el-radio-button label="2">奉贤</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item label="面试官" prop="interviewer">
              <el-select
                v-model="categoryForm.interviewer"
                @click.native="getAdminUser"
                multiple
                placeholder="请选择"
                style="width: 100%"
                size="mini"
                clearable
                filterable
              >
                <el-option
                  v-for="item in options_adminUsers"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-card>
          <div style="text-align: right; margin-top: 0.2rem">
            <el-button type="primary" size="mini" @click="submitForm('categoryForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <el-input v-model="editCategoryForm.categoryId" size="mini"></el-input>
          </el-form-item>
          <!-- <el-form-item label="是否显示" prop="display">
                  是
                  <el-switch
                    v-model="ifDisplay"
                    active-color="#ff4949"
                    inactive-color="#13ce66"
                  >
                  </el-switch>
                  否
                </el-form-item> -->
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      title="待审核信息"
      :visible.sync="examineDialog"
      fullscreen
      @close="clearExamineParams"
    >
      <div style="padding: 0.5rem, 1rem">
        <el-table
          max-height="650"
          :data="examineData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="序号" width="80" align="center" fixed="left">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称"
            width="200"
            fixed="left"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop=""
            label="是否1-2个月内到期"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                style="color: #f56c6c"
                v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth"
                >是</el-link
              >
              <span v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth === false"
                >否</span
              >
              <span
                style="color: #f56c6c; margin-left: 0.1rem"
                v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth"
                >{{ scope.row.fin_reg.end_time }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="待办事项是否完成"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                style="color: #f56c6c"
                @click="openUnMatterOvered(scope.row.id)"
                v-if="scope.row.matterOvered !== null && scope.row.matterOvered"
                >未完成</el-link
              >
              <span v-if="scope.row.matterOvered !== null && !scope.row.matterOvered"
                >完成</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="是否有企业微信群"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link style="color: #f56c6c" v-if="scope.row.wx_work_chat">是</el-link>
              <span v-else scope.row.matterOvered>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="" width="280" show-overflow-tooltip align="center">
            <!-- label="是否已检查群内近30天的聊天记录" -->
            <template slot="header">
              <span>
                <!-- <el-checkbox
                        v-model="groupInput"
                        @change="checkedgroup"
                      ></el-checkbox> -->
                群内人员是否存在被交接人</span
              >
            </template>
            <template slot-scope="scope">
              <!-- <el-checkbox
                    v-if="scope.row.wx_work_chat"
                      v-model="groupInputSon[scope.row.id]"
                      @change="groupChange($event, scope.row.id)"
                    ></el-checkbox> -->
              <el-link
                style="color: #f56c6c"
                v-if="scope.row.examine_group && scope.row.wx_work_chat"
                >是</el-link
              >
              <span v-if="!scope.row.examine_group && scope.row.wx_work_chat">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="" width="280" show-overflow-tooltip align="center">
            <!-- label="是否已检查群内近30天的聊天记录" -->
            <template slot="header">
              <span>
                <!-- <el-checkbox
                        v-model="chatInput"
                        @change="checkedChat"
                      ></el-checkbox> -->
                是否已检查群内近30天的聊天记录</span
              >
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.examine_chat">是</span>
              <span v-else style="color: #f56c6c">否</span>
              <!-- <el-checkbox
                      v-model="chatInputSon[scope.row.id]"
                      @change="chatChange($event,scope.row.id)"
                    ></el-checkbox> -->
            </template>
          </el-table-column>
          <el-table-column prop="" width="270" show-overflow-tooltip align="center">
            <!-- label="是否已进行财务报表及报税检查" -->
            <template slot="header">
              <span>
                <!-- <el-checkbox
                        v-model="taxInput"
                        @change="checkedTax"
                      ></el-checkbox> -->
                是否已进行财务报表及报税检查</span
              >
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.examine_tax">是</span>
              <span v-else style="color: #f56c6c">否</span>
              <!-- <el-checkbox v-model="taxInputSon[scope.row.id]" @change="taxChange($event,scope.row.id)"></el-checkbox> -->
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="交接职位及新人员"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <p v-for="(value, key) in scope.row.position" :key="key">
                {{ key + ":" + value }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="" width="220" show-overflow-tooltip align="center">
            <!-- label="是否已进行财务报表及报税检查" -->
            <template slot="header">
              <span>
                <!-- <el-checkbox
                        v-model="taxInput"
                        @change="checkedTax"
                      ></el-checkbox> -->
                审核通过请勾选</span
              >
              <i style="margin-top: 0.1rem; color: #e6a23c" class="el-icon-s-opportunity"
                >勾选的同时会自动完成交接</i
              >
            </template>
            <!-- <template slot-scope="scope">
                  <el-checkbox
                    v-if="scope.row.is_examined"
                    v-model="examine[scope.row.id]"
                    @change="examineChange($event, scope.row.id, scope.$index)"
                    disabled
                    checked
                  ></el-checkbox>
                  <el-checkbox
                    v-else
                    v-model="examine[scope.row.id]"
                    @change="examineChange($event, scope.row.id, scope.$index)"
                  ></el-checkbox>
                </template> -->
            <template slot-scope="scope">
              <input
                type="checkbox"
                v-if="scope.row.is_examined"
                @change="examineChange($event, scope.row.id, scope.$index)"
                disabled
                checked
              />
              <input
                type="checkbox"
                v-else
                @change="examineChange($event, scope.row.id, scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
          <el-pagination
            @size-change="handleSizeChange_inside"
            @current-change="handleCurrentChange_inside"
            :current-page.sync="npage_inside"
            :page-sizes="[10, 15, 30, 50, 100]"
            :page-size="pageSize_inside"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_inside"
            background
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-drawer
      title=""
      :visible.sync="ServiceTimeDrawer"
      direction="rtl"
      :before-close="handleCloseServiceTimeDrawer"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">服务时间</span>
      </template>
      <service-time :tyc_order_data="tycOrderData" />
    </el-drawer>
    <el-drawer
      :visible.sync="handOutDraw"
      :direction="direction"
      :before-close="handleOutDrawClose"
      size="35%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: large">交接出财税登记表</span>
      </template>
      <div style="padding: 0.2em 1.4em">
        <el-form
          :model="handOutForm"
          :rules="handOutRule"
          ref="handOutForm"
          label-width="80px"
        >
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>交接出原因</span>
            </div>
            <div style="white-space: nowrap">
              <el-form-item label-width="90px" label="交接出原因" prop="reason">
                <el-input
                  type="textarea"
                  v-model="handOutForm.reason"
                  size="medium"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div style="white-space: nowrap">
              <el-form-item label-width="90px" label="是否委托注销" prop="unregister">
                <el-radio-group v-model="handOutForm.unregister">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
                <el-button
                  style="margin-left: 0.2rem"
                  type="primary"
                  size="mini"
                  @click="handOutForm.unregister = ''"
                  >清除</el-button
                >
              </el-form-item>
            </div>
          </el-card>
          <div style="text-align: right; margin-top: 0.2rem">
            <el-button
              type="primary"
              size="mini"
              @click="submitHandOutForm('handOutForm')"
              >提交</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="addServiceTimeDrawer"
      direction="rtl"
      :before-close="handleCloseAddServiceTime"
      size="35%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold"
          >增加服务时间</span
        >
      </template>
      <div style="padding: 0 0.5rem">
        <el-form :model="addServiceTime" ref="addServiceTime" label-width="80px">
          <el-card shadow="always">
            <div slot="header">
              <span>服务时间信息</span>
            </div>
            <div style="font-size: medium">
              <div
                v-for="(item, index) in serviceTimeOptions"
                :key="item.id"
                style="
                  display: flex;
                  background-color: #409eff;
                  color: snow;
                  border-radius: 5px;
                  padding: 0.2rem;
                "
                class="mb2"
              >
                <div style="">
                  <div class="mb2">
                    <span>订单号:</span>
                    <span>{{ item.order_num }}</span>
                  </div>
                  <div>
                    <div>
                      <p class="mb1">
                        <span>服务开始时间:</span>
                        <span v-if="item.service_started_at">{{
                          item.service_started_at
                        }}</span>
                        <el-date-picker
                          v-else
                          v-model="item.service_started_at"
                          type="date"
                          align="right"
                          value-format="yyyy-MM-dd"
                          style="display: inline-block"
                          size="mini"
                        >
                        </el-date-picker>
                      </p>
                      <p class="mb1">
                        <span>服务到期时间:</span>
                        <span v-if="item.service_ended_at">{{
                          item.service_ended_at
                        }}</span>
                        <el-date-picker
                          v-else
                          v-model="item.service_ended_at"
                          type="date"
                          align="right"
                          value-format="yyyy-MM-dd"
                          style="display: inline-block"
                          size="mini"
                        >
                        </el-date-picker>
                      </p>
                    </div>
                  </div>
                </div>
                <div style="margin-left: auto; cursor: pointer">
                  <i class="el-icon-delete" @click="delServiceTimeInfo(index)"></i>
                </div>
              </div>
            </div>
          </el-card>
          <div style="text-align: right; margin-top: 0.2rem">
            <el-button type="primary" size="medium" @click="HandleSaveServiceTime"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="editDrawer"
      direction="rtl"
      :before-close="handleCloseEdit"
      size="35%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold">修改</span>
      </template>
      <div style="padding: 0 0.5rem">
        <el-form :model="editForm" ref="editForm" :rules="editRule" label-width="100px">
          <el-card shadow="always">
            <div slot="header">
              <span>基本信息</span>
            </div>
            <div>
              <el-form-item label="服务状态" prop="service_state">
                <el-radio-group v-model="editForm.service_state" size="mini">
                  <el-radio-button :label="1">正常</el-radio-button>
                  <el-radio-button :label="2">逾期(欠费)</el-radio-button>
                  <el-radio-button :label="3">已交接</el-radio-button>
                  <el-radio-button :label="4">已注销</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="收费标准" prop="take_money_rule">
                <el-input
                  type="number"
                  v-model="editForm.take_money_rule"
                  placeholder="收费标准"
                  size="medium"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="纳税人情况" prop="tax_types">
                <el-radio-group v-model="editForm.tax_types" size="mini">
                  <el-radio-button :label="2">小规模</el-radio-button>
                  <el-radio-button :label="3">一般纳税人</el-radio-button>
                  <el-radio-button :label="0">未知</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="托管开票" prop="custody_invoicing">
                <el-radio-group v-model="editForm.custody_invoicing" size="mini">
                  <el-radio-button :label="1">是</el-radio-button>
                  <el-radio-button :label="2">否</el-radio-button>
                  <el-radio-button :label="0">未知</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="人事托管项目" prop="personnel_matters_custody">
                <el-checkbox-group v-model="editForm.personnel_matters_custody">
                  <el-checkbox :label="1">社保</el-checkbox>
                  <el-checkbox :label="2">公积金</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-card>
          <div style="text-align: right; margin-top: 0.2rem">
            <el-button type="primary" size="medium" @click="HandleSubmitForm('editForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <div class="middle-table">
      <el-table
        ref="table_list"
        height="calc(100vh - 356px)"
        :data="categoryData"
        style="width: 100%; margin-top: 10px"
        border
        size="mini"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
        id="forStyle"
      >
        <div v-for="item in diyAllList" :key="item.key">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.key"
            v-if="!item.notShow && item.else"
            :show-overflow-tooltip="item.tooltip"
            :fixed="item.key === 'company_name' || item.key === 'company_id'"
            :width="item.width"
          >
          </el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.key"
            v-if="!item.notShow && !item.else"
            :show-overflow-tooltip="item.tooltip"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.key === 'service_range'">
                <el-link
                  type="primary"
                  v-if="
                    scope.row.service_time.length > 0 && scope.row.service_time.length > 1
                  "
                  @click="openServiceTimeDrawer(scope.row.service_time)"
                  >点击查看</el-link
                >
                <!-- <el-link v-if="scope.row.service_time.length > 0 && scope.row.service_time.length === 1 && (scope.row.service_time[0].taxation_service_time.service_started_at || scope.row.service_time[0].taxation_service_time.service_ended_at)" 
                                @click="openServiceTimeDrawer(scope.row.service_time)">{{
                                    scope.row.service_time[0].taxation_service_time.service_started_at ? scope.row.service_time[0].taxation_service_time.service_started_at : '未知' + '至' +
                                    scope.row.service_time[0].taxation_service_time.service_ended_at ? scope.row.service_time[0].taxation_service_time.service_ended_at : '未知'}}</el-link> -->
                <el-link
                  v-if="
                    scope.row.service_time.length > 0 &&
                    scope.row.service_time.length === 1 &&
                    (scope.row.service_time[0].taxation_service_time.service_started_at ||
                      scope.row.service_time[0].taxation_service_time.service_ended_at)
                  "
                  @click="openServiceTimeDrawer(scope.row.service_time)"
                  >{{
                    scope.row.service_time[0].taxation_service_time.service_started_at
                      ? scope.row.service_time[0].taxation_service_time.service_started_at.substring(
                          0,
                          7
                        )
                      : "未知"
                  }}
                  至
                  {{
                    scope.row.service_time[0].taxation_service_time.service_ended_at
                      ? scope.row.service_time[0].taxation_service_time.service_ended_at.substring(
                          0,
                          7
                        )
                      : "未知"
                  }}</el-link
                >
              </div>
              <div v-else-if="item.key === 'tax_types'">
                <span
                  v-if="scope.row.com_fin_tax && scope.row.com_fin_tax.tax_types === 2"
                  >小规模</span
                >
                <span
                  v-else-if="
                    scope.row.com_fin_tax && scope.row.com_fin_tax.tax_types === 3
                  "
                  >一般纳税人</span
                >
              </div>
              <div v-else-if="item.key === 'is_zero_declare'">
                <span
                  v-if="
                    scope.row.com_fin_tax && scope.row.com_fin_tax.is_zero_declare === 1
                  "
                  >是</span
                >
                <span
                  v-else-if="
                    scope.row.com_fin_tax && scope.row.com_fin_tax.is_zero_declare === 2
                  "
                  >否</span
                >
              </div>
            </template>
          </el-table-column>
        </div>
        <!-- 注释保留 -->
        <!-- <el-table-column prop="company_id" label="公司ID">
            </el-table-column>
            <el-table-column prop="company.company_name" label="公司名称">
            </el-table-column>
            <el-table-column prop="service_state" label="服务状态">
            </el-table-column>
            <el-table-column prop="company.regStatus" label="企业状态">
            </el-table-column>
            <el-table-column prop="com_fin_tax.fin_charges" label="收费标准">
            </el-table-column>
            <el-table-column label="服务时间">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.tyc_order.length > 0"
                        @click="openServiceTimeDrawer(scope.row.tyc_order)">点击查看</el-link>
                </template>
            </el-table-column>
            <el-table-column label="纳税人情况">
                <template slot-scope="scope">
                    <span v-if="scope.row.com_fin_tax.tax_types === 2">小规模</span>
                    <span v-else-if="scope.row.com_fin_tax.tax_types === 3">一般纳税人</span>
                </template>
            </el-table-column>
            <el-table-column prop="custody_invoicing" label="托管开票">
            </el-table-column>
            <el-table-column prop="personnel_matters_custody" label="人事托管">
            </el-table-column>
            <el-table-column prop="company.adminuser.username" label="所属业务">
            </el-table-column>
            <el-table-column prop="admin_user.username" label="所属财务">
            </el-table-column>
            <el-table-column prop="notes" label="备注">
            </el-table-column>
            <el-table-column prop="created_at" label="首次加入财税登记表时间"></el-table-column> -->
        <el-table-column label="操作" width="240" align="center">
          <el-table-column label="销售" width="140">
            <template slot-scope="scope">
              <!-- <el-tooltip class="item" effect="dark" content="修改" placement="top">
                        <el-button @click.native.prevent="handleEdit(scope.row)" type="primary" size="mini"
                            icon="el-icon-edit" circle>
                        </el-button>
                    </el-tooltip> -->
              <el-tooltip
                class="item"
                effect="dark"
                content="增加服务时间"
                placement="top"
              >
                <el-button
                  @click.native.prevent="handleAddServiceTime(scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-circle-plus-outline"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="编辑(销售)" placement="top">
                <el-button
                  @click.native.prevent="handleEdit(scope.row, scope.$index)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="提交交接出财税登记表申请"
                placement="top"
                v-if="scope.row.status === 1"
              >
                <!-- :disabled="scope.row.service_time.length === 0" -->
                <el-button
                  @click.native.prevent="handleHandOut(scope.$index, scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-s-promotion"
                  circle
                >
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="交接出审核中,点击打开交接出审核列表"
                placement="top"
                v-else-if="scope.row.status === 2"
              >
                <el-button
                  @click.native.prevent="$router.push('ft_hand_out')"
                  type="info"
                  size="mini"
                  icon="el-icon-s-promotion"
                  circle
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="财务" width="140"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="npage"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import upfile from "../../common/UpFile.vue";
import Vue from "vue";
import CompanyInfo from "common/CompanyInfo";
import ServiceTime from "./components/ServiceTime";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "FinanceTaxation",
  mixins: [fscDate],
  components: { CompanyInfo, upfile, ServiceTime },
  data() {
    Vue.directive("down", {
      inserted: (el, binding) => {
        el.style.cssText = "cursor: pointer;color:write;";
        el.addEventListener("click", () => {
          // console.log(binding.value)
          let link = document.createElement("a");
          let image = document.createElement("image");
          let url = binding.value;
          let downloadName = url.slice(url.lastIndexOf("/") + 1);
          // console.log(downloadName);
          // 这里是将url转成blob地址，
          image.setAttribute("crossOrigin", "anonymous"); // 这句可以解决跨域问题
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob);
              // console.log(link.href)
              link.download = downloadName;
              document.body.appendChild(link);
              link.click();
            });
        });
      },
    });
    let checkPhone = (rule, value, callback) => {
      if (value !== "") {
        let reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输⼊有效的⼿机号码"));
        }
      }
      callback();
    };
    var validateLength = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        var reg = /^-?\d{1,10}(?:\.\d{1,2})?$/; // 小数点左边最高4位，小数点右边最多4位
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的数字,小数点后可1到2位"));
        }
      }
    };
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      typeinerOptions: [],
      treasurerOptions: [],
      addServiceTime: {},
      needCompanyId: null,
      serviceTimeOptions: [],
      editForm: {
        service_state: null,
        take_money_rule: "",
        tax_types: "",
        custody_invoicing: "",
        personnel_matters_custody: [],
      },
      editRule: {
        take_money_rule: [{ validator: validateLength, trigger: "blur" }],
      },
      needTaxationId: null,
      needTaxationIndex: null,
      addServiceTimeDrawer: false,
      editDrawer: false,
      finance_taxation_id: null,
      handOutDraw: false,
      hasListPower: false,
      onlyMe: null,
      isUpdatedOnlyMe: null,
      dropDownReverseModel: false,
      dropDownChooseAllModel: false,
      dropDownCheckList: [],
      dropDownWord: "自定义表头",
      submitDropDown: false,
      diyAllList: [
        {
          label: "公司名称",
          key: "company_name",
          prop: "company.company_name",
          width: 210,
          tooltip: true,
          else: true,
          sort: 2,
        },
        {
          label: "公司ID",
          key: "company_id",
          prop: "company_id",
          else: true,
          sort: 1,
        },
        {
          label: "服务状态",
          key: "service_state",
          prop: "service_state",
          else: true,
          sort: 3,
        },
        {
          label: "企业状态",
          key: "regStatus",
          prop: "company.regStatus",
          width: 100,
          else: true,
          sort: 4,
        },
        {
          label: "收费标准",
          key: "fin_charges",
          prop: "com_fin_tax.fin_charges",
          else: true,
          sort: 5,
        },
        {
          label: "服务时间",
          key: "service_range",
          prop: "",
          width: 180,
          sort: 6,
        },
        {
          label: "纳税人情况",
          key: "tax_types",
          prop: "",
          width: 100,
          sort: 7,
        },
        {
          label: "托管开票",
          key: "custody_invoicing",
          prop: "custody_invoicing",
          else: true,
          sort: 8,
        },
        {
          label: "人事托管",
          key: "personnel_matters_custody",
          prop: "personnel_matters_custody",
          width: 130,
          tooltip: true,
          else: true,
          sort: 9,
        },
        {
          label: "是否零申报",
          key: "is_zero_declare",
          prop: "com_fin_tax.is_zero_declare",
          width: 100,
          sort: 10,
        },
        {
          label: "所属业务",
          key: "salary",
          prop: "company.adminuser.username",
          else: true,
          sort: 11,
        },
        {
          label: "所属财务",
          key: "treasurer",
          prop: "com_fin_tax.leader.username",
          else: true,
          sort: 12,
        },
        {
          label: "备注",
          key: "notes",
          prop: "notes",
          width: 150,
          tooltip: true,
          else: true,
          sort: 13,
        },
        {
          label: "首次加入财税工厂时间",
          key: "fif_time",
          prop: "fif_time",
          width: 140,
          else: true,
          sort: 14,
        },
        {
          label: "本次加入财税工厂时间",
          key: "created_at",
          prop: "created_at",
          width: 140,
          else: true,
          sort: 15,
        },
      ],
      tycOrderData: [],
      ServiceTimeDrawer: false,
      companyComId: null,
      companyInfoDrawer: false,
      unMatterOveredId: "",
      pageSize_un: 10,
      total_un: 0,
      npage_un: 1,
      unMatterOveredData: [],
      unMatterOveredDrawer: false,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      change: false,
      aboutExId: "",
      FOptions: [],
      needUrl: [],
      fileList: [],
      limit: 10,
      distributeForm: {
        feedback: "",
        progress: "1",
      },
      examineFeed: {
        remark: "",
      },
      distributeDrawer: false,
      exmined: [],
      examine: [],
      examineId: "",
      examineDialog: false,
      pageSize_inside: 10,
      nowPage_inside: 1,
      total_inside: 0,
      npage_inside: 1,
      examineData: [],
      searchArr: {
        category_id: "",
        business_id: "",
        service_time: "",
        treasurer_id: "",
      },
      npage: 1,
      categoryPerPage: 30,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: "rtl",
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: "",
      branch: [],
      options_adminUsers: [],
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      categoryForm: {},
      handOutForm: {
        reason: "",
        unregister: "",
      },
      editCategoryForm: {
        categoryId: "",
        category_name: "",
        display: false,
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        meetAt: [{ required: true, message: "请选择面试时间", trigger: "blur" }],
        meet_place: [{ required: true, message: "请选择面试地点", trigger: "blur" }],
        station: [
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        feishuurl: [
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
      handOutRule: {
        reason: [
          { required: true, message: "请填写原因", trigger: "change" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 555 个字符",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  mounted() {
    this.loadTable();
  },
  beforeDestroy() {
    this.$bus.$off("ysyupfile");
    this.$bus.$off("ysyuperr");
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    submitDropDownMethod() {
      // console.log(this.dropDownCheckList)
      // return false
      let arr = [];
      this.diyAllList.map((item) => {
        if (this.dropDownCheckList.indexOf(item.key) !== -1) {
          arr.push(item.key);
        }
      });
      this.$axios
        .post("api/api3_finance_taxation_update_diy_table_head", {
          // tableHead: this.dropDownCheckList,
          tableHead: arr,
          table: "finance_taxations",
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.changeTableHead(data.data);
          }
        })
        .catch();
    },
    changeTableHead(data) {
      this.diyAllList.map((item) => {
        this.$set(item, "notShow", false);
        if (data.table_head_field.indexOf(item.key) === -1) {
          this.$set(item, "notShow", true);
        }
      });
      this.$nextTick(() => {
        this.$refs.table_list.doLayout();
      });
    },
    dropDownChooseAllChange(val) {
      if (val) {
        this.dropDownReverseModel = false;
        this.dropDownCheckList = [];
        // console.log(this.diyAllList)
        this.diyAllList.map((item) => {
          this.dropDownCheckList.push(item.key);
        });
      } else {
      }
    },
    dropDownReverseChange(val) {
      if (val) {
        this.dropDownChooseAllModel = false;
        this.diyAllList.map((item) => {
          var index = this.dropDownCheckList.indexOf(item.key);
          if (index !== -1) {
            this.dropDownCheckList.splice(index, 1);
          } else {
            this.dropDownCheckList.push(item.key);
          }
        });
      } else {
      }
    },
    changeWord(val) {
      if (val) {
        this.dropDownWord = "提交";
        this.submitDropDown = true;
      } else {
        this.dropDownWord = "自定义表头";
        this.submitDropDown = false;
      }
    },
    openServiceTimeDrawer(data) {
      this.ServiceTimeDrawer = true;
      this.$nextTick((_) => {
        this.tycOrderData = data;
      });
    },
    openUrl(url) {
      let newPage = this.$router.resolve({
        path: "/documentation",
        query: { url: url },
      });
      window.open(newPage.href, "_blank");
    },
    getAdminUser() {
      this.$axios.get("/api/admin/users").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.options_adminUsers = data.data.users;
          this.roles = data.data.roles;
          this.statistical = data.data.statistical;
        }
      });
    },
    getUser() {
      this.$axios.get("/api/admin/users").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.users = data.data.users;
          this.roles = data.data.roles;
          this.branch = data.data.branch;
          this.statistical = data.data.statistical;
        }
      });
    },
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    handleSizeChange_un(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_un = val;
      this.getUnMatterOveredData();
    },
    handleCurrentChange_un(val) {
      this.npage_un = val;
      this.getUnMatterOveredData();
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.id;
      });
    },
    openCompanyCom_examine(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.company_id;
      });
    },
    closeUnMatterOveredDrawer() {
      this.unMatterOveredId = "";
      this.unMatterOveredData = [];
    },
    getUnMatterOveredData() {
      if (!this.unMatterOveredId) return false;
      this.$axios
        .get(
          "api/finance-taxation/get_matter_un?page" +
            this.npage_un +
            "&perPage=" +
            this.pageSize_un +
            "&cid=" +
            this.unMatterOveredId
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.unMatterOveredData = data.data.data;
            this.total_un = data.data.total;
          }
        })
        .catch();
    },
    openUnMatterOvered(id) {
      this.unMatterOveredId = id;
      this.getUnMatterOveredData();
      this.unMatterOveredDrawer = true;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / 1024 / 1024 < 100;

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error("上传总大小不能超过 100MB!");
        return false;
      }
      // return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange(res, file) {
      this.fileList = file;
      this.change = true;
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name;
    },
    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1);
        }
      });
      this.fileList = fileList;
      this.change = true;
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile();
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },
    submitDisForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.distributeForm.file = this.needUrl;
          this.distributeForm.id = this.aboutExId;
          this.$axios
            .post("api/finance-taxation/store", this.distributeForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.distributeDrawer = false;
                this.$refs.distributeForm.resetFields();
                this.fileList = [];
                this.needUrl = [];
                this.change = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    handleSizeChange_inside(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_inside = val;
      this.loadTable_inside();
    },
    handleCurrentChange_inside(val) {
      this.npage_inside = val;
      this.loadTable_inside();
    },
    clearExamineParams() {
      let check = document.getElementsByTagName("input");
      let arr = Array.from(check);
      console.log(arr);
      arr.map((item) => {
        item.checked = false;
      });
      // for (var i in this.examine) {
      //   this.examine[i] = false
      // }
      // this.examine.map((item, index) => {
      //   this.examine.splice(index, 1)
      // })
      this.examineId = "";
    },
    loadTable_inside() {
      this.$axios
        .get("api/finance-taxation/" + this.examineId, {
          params: {
            page: this.npage_inside,
            perpage: this.pageSize_inside,
            // searchItem: this.searcher
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.examineData = data.data.data;
            this.total_inside = data.data.total;
            // this.loadRadio()
            // this.loadSort()
          }
        })
        .catch();
    },
    examineChange(val, id, index) {
      if (val) {
        this.$axios
          .put("api/finance-taxation/" + this.examineId, {
            company_id: id,
          })
          .then(({ data }) => {
            if (data.code === 1) {
              // this.exmined.push(id)
              // this.examineData[index].is_examined = true
              this.loadTable_inside();
              this.loadTable();
              this.$message.success(data.msg);
              //   this.examineData = data.data.data
              //   this.total_inside = data.data.total
              // this.loadRadio()
              // this.loadSort()
            }
          })
          .catch();
      }
    },
    openNameRow(id) {
      this.examineId = id;
      this.loadTable_inside();
      this.examineDialog = true;
    },
    showOnlyMe() {
      this.isUpdatedOnlyMe = true;
      this.loadTable();
    },
    loadTable() {
      this.$axios
        .get("api/api3_finance_taxation_list", {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searchArr,
            onlyMe: this.onlyMe,
            isUpdatedOnlyMe: this.isUpdatedOnlyMe,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.hasListPower = data.power;
            this.fillDropDownCheckBox(data.config, data.data.data, data.data.total);
            this.isUpdatedOnlyMe = null;
            this.onlyMe = data.onlyMe === "true" ? true : null;
            // this.changeTableHead(data.config)
            // this.categoryData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch();
    },
    fillDropDownCheckBox(config, data, total) {
      this.dropDownCheckList = [];
      if (config && config.table_head_field) {
        config.table_head_field.map((item) => {
          this.dropDownCheckList.push(item);
        });
        this.changeTableHead(config);
      } else {
        this.defaultChoosed();
      }
      this.categoryData = data;
      this.total = total;
    },
    defaultChoosed() {
      this.dropDownCheckList = [];
      this.diyAllList.map((item) => {
        this.$set(item, "notShow", false);
        this.dropDownCheckList.push(item.key);
      });
    },
    loadRadio() {
      this.categoryData.map((item) => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false;
        } else {
          this.ListIfDisplay[item.id] = true;
        }
      });
    },
    loadSort() {
      this.categoryData.map((item) => {
        this.listSort[item.id] = Number(item.sort);
      });
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleSizeChange(val) {
      this.categoryPerPage = val;
      this.loadTable();
    },
    handleClose(done) {},
    editRow(id) {
      this.$axios
        .put("api/finance-taxation/all_examined/" + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          }
        })
        .catch();
    },
    handleHandOut(index, row) {
      if (row.service_time.length === 0) {
        this.$message.warning("请先完善服务时间信息!");
        return false;
      }
      this.finance_taxation_id = row.id;
      this.handOutDraw = true;
    },
    searchRemoteCfcategory(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchCategories = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/api3_finance_taxation_remote_search_company", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.searchCategories = data.data;
          }
        })
        .catch();
    },
    handleSearchCfcategory(query) {
      // this.searcher = query
      this.loadTable();
    },
    categoryIn() {
      this.categoryIndrawer = true;
    },
    handleOutDrawClose(done) {
      // this.$confirm('确认关闭？')
      //     .then((_) => {
      this.$refs.handOutForm.resetFields();
      this.finance_taxation_id = null;
      done();
      // })
      // .catch((_) => { })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.categoryForm.file = this.needUrl;
          this.$axios
            .post("api/recruit_manage_store", this.categoryForm)
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.$refs.categoryForm.resetFields();
                this.$bus.$emit("ysyclearrm");
                this.categoryIndrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitHandOutForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/api3_finance_taxation_submit_hand_out", {
              finance_taxation_id: this.finance_taxation_id,
              out_reason: this.handOutForm.reason,
              unregister: this.handOutForm.unregister,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 200) {
                this.$message.success(data.msg);
                // this.$refs.categoryForm.resetFields()
                // this.$bus.$emit('ysyclearrm')
                this.handOutDraw = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put("api/advicecate/edit", {
              id: this.category,
              category_name: this.editCategoryForm.categoryId,
              display: this.ifDisplay === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.categoryEditDrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editListRadio(row) {
      this.$axios
        .put("api/advicecate/listshow", {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    setSort(row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error("排序值为数字！");
        return false;
      }
      this.$axios
        .put("api/advicecate/setsort", {
          id: row.id,
          sort: this.listSort[row.id],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleCloseServiceTimeDrawer(done) {
      // this.$confirm('确认关闭？')
      //   .then((_) => {
      this.tycOrderData = [];
      done();
      //   })
      //   .catch((_) => {})
    },
    openExamineFeed(id) {
      this.aboutExId = id;
      this.$axios
        .get("api/finance-taxation/" + id + "/edit")
        .then(({ data }) => {
          if (data.code === 1) {
            this.FOptions = data.data;
            let obj = data.data[0];
            this.distributeForm.progress = obj ? obj.progress : 1;
          }
        })
        .catch();
      this.distributeDrawer = true;
    },
    handleEdit(row, index) {
      this.needTaxationId = row.id;
      this.needTaxationIndex = index;
      let obj = {
        正常: 1,
        "逾期(欠费)": 2,
        已交接: 3,
        已注销: 4,
      };
      this.editForm.service_state = obj[row.service_state];
      if (row.com_fin_tax) {
        this.editForm.take_money_rule = row.com_fin_tax.fin_charges;
        this.editForm.tax_types = row.com_fin_tax.tax_types
          ? row.com_fin_tax.tax_types
          : 0;
      }
      let obj_cus = {
        是: 1,
        否: 2,
      };
      this.editForm.custody_invoicing = row.custody_invoicing
        ? obj_cus[row.custody_invoicing]
        : 0;
      let obj_per = {
        社保: 1,
        公积金: 2,
      };
      if (row.personnel_matters_custody) {
        row.personnel_matters_custody.split(",").map((item) => {
          this.editForm.personnel_matters_custody.push(obj_per[item]);
        });
      }

      this.editDrawer = true;
    },
    handleCloseEdit(done) {
      this.needTaxationId = null;
      this.needTaxationIndex = null;
      this.editForm = this.$options.data().editForm;
      done();
    },
    handleAddServiceTime(row) {
      this.needCompanyId = row.company_id;
      this.$axios
        .get("api/api3_finance_taxation_get_service_time_except_already_has", {
          params: {
            company_id: row.company_id,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.serviceTimeOptions = data.data;
          }
        })
        .catch();
      this.addServiceTimeDrawer = true;
    },
    handleCloseAddServiceTime(done) {
      this.needCompanyId = null;
      this.serviceTimeOptions = [];
      done();
    },
    HandleSaveServiceTime() {
      try {
        this.serviceTimeOptions.map((item) => {
          if (!item.service_started_at || !item.service_ended_at) {
            this.$message.error("请填写所选订单的服务时间!!!");
            throw new Error();
          }
        });
      } catch (err) {
        return false;
      }

      if (this.serviceTimeOptions.length === 0) {
        return false;
      }

      this.$axios
        .put("api/api3_finance_taxation_add_service_time", {
          company_id: this.needCompanyId,
          serviceTime: this.serviceTimeOptions,
        })
        .then(({ data }) => {
          this.$message.success(data.msg);
          this.loadTable();
          this.addServiceTimeDrawer = false;
        })
        .catch();
    },
    delServiceTimeInfo(index) {
      this.serviceTimeOptions.splice(index, 1);
    },
    loadTypeiner() {
      setTimeout(() => {
        this.$axios
          .get("api/admin/user/branch")
          .then(({ data }) => {
            if (data.code === 1) {
              this.typeinerOptions = data.data;
              this.typeinerOptions.unshift({
                value: "n",
                label: "没有业务员的",
              });
            }
          })
          .catch();
      }, 200);
    },
    loadTreasurer() {
      setTimeout(() => {
        this.$axios
          .get("api/admin/user/branch")
          .then(({ data }) => {
            if (data.code === 1) {
              this.treasurerOptions = data.data;
              this.treasurerOptions.unshift({
                value: "n",
                label: "没有所属财务的",
              });
            }
          })
          .catch();
      }, 200);
    },
    HandleReset() {
      this.searchArr.business_id = "";
      this.searchArr.service_time = "";
      this.searchArr.treasurer_id = "";
    },
    HandleQuery() {
      this.npage = 1;
      this.loadTable();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    HandleSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put("api/api3_finance_taxation_edit", {
              editForm: this.editForm,
              id: this.needTaxationId,
            })
            .then(({ data }) => {
              if (data.code === 200) {
                if (this.categoryData[this.needTaxationIndex].com_fin_tax) {
                  this.categoryData[this.needTaxationIndex].com_fin_tax.fin_charges =
                    data.data.com_fin_tax.fin_charges;
                  this.categoryData[this.needTaxationIndex].com_fin_tax.tax_types =
                    data.data.com_fin_tax.tax_types;
                } else {
                  this.categoryData[this.needTaxationIndex].com_fin_tax = {};
                  Object.defineProperty(
                    this.categoryData[this.needTaxationIndex].com_fin_tax,
                    "fin_charges",
                    {
                      value: data.data.com_fin_tax.fin_charges,
                      writeable: true,
                      enumerable: true,
                      configurable: true,
                    }
                  );
                  Object.defineProperty(
                    this.categoryData[this.needTaxationIndex].com_fin_tax,
                    "tax_types",
                    {
                      value: data.data.com_fin_tax.tax_types,
                      writeable: true,
                      enumerable: true,
                      configurable: true,
                    }
                  );
                  // this.categoryData[this.needTaxationIndex].com_fin_tax.fin_charges = data.data.com_fin_tax.fin_charges
                  // this.categoryData[this.needTaxationIndex].com_fin_tax.tax_types = data.data.com_fin_tax.tax_types
                }
                this.categoryData[this.needTaxationIndex].personnel_matters_custody =
                  data.data.personnel_matters_custody;
                this.categoryData[this.needTaxationIndex].custody_invoicing =
                  data.data.custody_invoicing;
                this.categoryData[this.needTaxationIndex].service_state =
                  data.data.service_state;
                this.editForm = this.$options.data().editForm;
                this.needTaxationId = null;
                this.needTaxationIndex = null;
                this.editDrawer = false;
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.finance-taxation {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.finance-taxation >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.middle-table {
  z-index: 1;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

#forStyle >>> .demo-table-expand {
  font-size: 0;
}

#forStyle >>> .demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

#forStyle >>> .demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  display: block;
}

.mb2 {
  margin-bottom: 0.2rem;
}

.mb1 {
  margin-bottom: 0.1rem;
}

#collapse >>> .el-collapse-item__wrap {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/financeTaxation/FinanceTaxation.vue